import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import formatDate from '../../../helpers/format-date';
import { MissingCrate } from 'src/models/Crate';

@Component({
  selector: 'app-missing-pallet-details',
  templateUrl: './missing-pallet-details.component.html',
  styleUrls: ['./missing-pallet-details.component.scss']
})
export class MissingPalletDetailsComponent implements OnInit {
  @Input() crate: MissingCrate;
  @Output() inventoryClicked = new EventEmitter();
  displayedColumns = ['name', 'sku', 'packSize', 'quantity'];
  columnsDefinition = [
    { key: 'name', text: "Nome" },
    { key: "packSize", text: 'Tamanho do pacote', alignRight: true },
    { key: "sku", text: 'Código do Item' },
    { key: "quantity", text: 'Quantidade', alignRight: true }
  ];
  dataSource: any[] = [];

  constructor() { }

  ngOnInit(): void {
    this.dataSource = this.crate.skuGroups;
  }

  formatDate(date) {
    return formatDate(date);
  }

  openInventorySidenav(crate) {
    this.inventoryClicked.emit(crate);
  }

}
